<div class="select-container-v2" [formGroup]="parentFormGroup">
  <mat-form-field appearance="outline" [floatLabel]="'always'">
    <mat-select
      id="{{ id }}"
      [formControlName]="formName"
      required
      (valueChange)="emit()"
      placeholder="{{ 'general.choisir' | translate }}"
      aria-labelledby="{{ accessibilityLabel }}"
      class="select-input"
    >
      <mat-option *ngFor="let frequence of frequences" [value]="frequence.id" [id]="'frequence-' + frequence.id">{{
        frequence.label
      }}</mat-option>
    </mat-select>
    <mat-error
      class="error-messages"
      id="erreur-{{ id }}"
      *ngIf="parentFormGroup.controls[this.formName].errors?.required"
    >
      <span class="sr-only">{{ 'erreur.general' | translate }}</span>
      {{ 'erreur.choisir-option' | translate }}
    </mat-error>
  </mat-form-field>
</div>
